export default "__VITE_ASSET__B8VkavP___"